export default __webpack_public_path__ + "static/banner_back_img-3b6fa4c7df6cfb84fa7fc5c1bb88de22.png";